import React from 'react';
import { connect } from 'react-redux';
import { reportDWH } from '../../WifiManagementBlockSlice';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import ContactUsAction from '../../../../Shared/ContactUs/ContactUsAction';
import './errorPage.scss';

const ErrorPage = (props) => {
    const errorDescription = props.errorDescription;

    let title = null;
    let subTitle = null;
    let buttonTitle = null;
    let icon = 'error-icon';
    let handleOnContinue = handleGoToLobby;
    let btnText = 'הבנתי, תודה';

    switch (errorDescription) {
        case 'NO_SUBSCRIBER_ERROR':
        //case 'PAYMENT_OR_DEBT_ERROR':
            title = <> מצטערים, אנחנו לא מזהים שיש לכם שירות אינטרנט </>;
            subTitle = <> יכול להיות שנרשמתם עם פרטים אחרים? <br/> שווה לנסות להתחבר שוב </>;
            btnText = 'לאיזור האישי';
            break;  
        case 'ROUTER_NOT_ALLOWED_IN_EPI_ERROR':
            title = (
                <>
                    <span className="text-line text-line--nowrap">לא ניתן לנהל את הגדרות ה-<span dir="ltr">Wi-Fi</span></span>
                    <span className="text-line">בנתב שברשותך</span>
                </>
            );
            subTitle = <>נשמח לסייע לך ב- <span dir="ltr">{window.Config.technicalSupportPhone}</span></>;
            btnText = 'לאיזור האישי';
            break;
        case 'GET_WIFI_DATA_ERROR':
        case 'NOT_JET_CUSTOMER_ERROR':
        case 'INFRASTRUCTURE_ERROR':
        case 'FOREIGN_EQUIPMENTS_ERROR':
            title = <> יש לפנות לתמיכה להמשך <br/> קבלת העזרה</>;
            buttonTitle = 'נשמח לסייע לך';
            btnText = 'לאיזור האישי';
            break;

        case 'UPDATE_WIFI_DATA_ERROR':
            title = <> מצטערים, משהו השתבש והפרטים לא עודכנו </>;
            btnText = 'לאיזור האישי';
            break;
    }



    return (
        <div className='error-page' data-error={errorDescription}>

            <div className={icon}></div>

            {title && <div className='page-title'>{title}</div>}
            {subTitle && <div className='page-sub-title'>{subTitle}</div>}

            {
                errorDescription == 'NO_SUBSCRIBER_ERROR' && props.joinServiceLink &&
                <div className='link-wrapper'>
                    <a href='#' onClick={(e) => { handleJoinServiceClick(e, props.joinServiceLink) }}>לחצו כאן להצטרפות לשירות</a>
                </div>
            }

            {buttonTitle && (
                <div className='contact-us-wrapper'>
                    <div className='contact-us-title'>{buttonTitle}</div>
                    <ContactUsAction
                        contentData={{
                            title: { value: `חייג עכשיו ${window.Config.technicalSupportPhone}` },
                            phoneNumber: { value: window.Config.technicalSupportPhone },
                            actionType: { value: 'phone' },
                            icon: { value: null }
                        }}
                    />
                </div>
            )}

            <div className='button-wrapper'>
                <BtnSubmit text={btnText} onclick={handleOnContinue} formid='error-page' />
            </div>
        </div>
    );

    function handleJoinServiceClick(e, url) {
        buildUrlAndOpenSameWindow(url);
    }

    function handleGoToLobby() {
        buildUrlAndOpenSameWindow(Config.lobbyUrl);
    }

};

const mapStateToProps = (state) => {
    return {
        errorDescription: state.wifiManagementBlock.errorDescription,
        joinServiceLink: state.wifiManagementBlock.joinServiceLink
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
